<template>
	<el-dialog
		title="资源签约"
		:visible.sync="dialogVisible"
		width="40%"
		top="10vh"
		:close-on-click-modal="false"
		:before-close="handleClose"
		custom-class="plan-dialog">
		<el-form ref="form" :model="form" :rules="rules" label-position="top" size="mini">
			<el-row :gutter="20">
				<!-- 资源名称 -->
				<el-col :span="12">
					<el-form-item label="资源名称" prop="resourceName">
						<el-input v-model="form.resourceName" size="small" placeholder="请填写资源名称" />
					</el-form-item>
				</el-col>

				<!-- 资源编号 -->
				<el-col :span="12">
					<el-form-item label="资源编号" prop="resourceNo">
						<el-input v-model="form.resourceNo" size="small" placeholder="请填写资源编号" />
					</el-form-item>
				</el-col>

				<!-- 资源类型 -->
				<el-col :span="12">
					<el-form-item label="资源类型" prop="resourceType">
						<el-select
							v-model="form.resourceType"
							size="small"
							placeholder="请选择资源类型"
							clearable
							style="width: 100%">
							<el-option
								v-for="(item, index) in $menu.getList('ResourceType')"
								:key="index"
								:label="item.name"
								:value="item.value" />
						</el-select>
					</el-form-item>
				</el-col>

				<!-- 所属项目 -->
				<el-col :span="12">
					<el-form-item label="所属项目" prop="communityId">
						<el-select v-model="form.communityId" size="small" disabled placeholder="请选择所属项目">
							<el-option
								v-for="item in CurrentCommunity"
								:key="item.communityId"
								:label="item.name"
								:value="item.communityId" />
						</el-select>
					</el-form-item>
				</el-col>

				<!-- 关联资产 -->
				<el-col :span="12">
					<el-form-item label="关联资产" prop="assetId">
						<el-select
							v-model="form.assetId"
							size="small"
							:loading="loading"
							filterable
							remote
							reserve-keyword
							:remote-method="remoteMethod"
							placeholder="请选择关联资产">
							<el-option v-for="item in options" :key="item.id" :label="item.assetName" :value="item.id" />
						</el-select>
					</el-form-item>
				</el-col>

				<!-- 面积(㎡) -->
				<el-col :span="12">
					<el-form-item label="面积(㎡)" prop="area">
						<el-input
							v-model.number="form.area"
							type="number"
							size="small"
							placeholder="请填写面积"
							class="no-spinner" />
					</el-form-item>
				</el-col>

				<!-- 租金单价(元/㎡/月或元/月) -->
				<el-col :span="12">
					<el-form-item label="租金单价(元/㎡/月或元/月)" prop="rentPrice">
						<el-input
							v-model.number="form.rentPrice"
							type="number"
							size="small"
							placeholder="请填写租金单价"
							class="no-spinner" />
					</el-form-item>
				</el-col>

				<!-- 初始状态 -->
				<el-col :span="12">
					<el-form-item label="初始状态" prop="initialStatus">
						<el-select v-model="form.initialStatus" placeholder="请选择初始状态" size="small">
							<el-option
								v-for="(item, index) in $menu.getList('RentalStatus')"
								:key="index"
								:label="item.name"
								:value="item.value" />
						</el-select>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>

		<!-- 按钮 -->
		<span slot="footer">
			<el-button @click="handleClose">取 消</el-button>
			<el-button type="primary" @click="handleSubmit">确 定</el-button>
		</span>
	</el-dialog>
</template>

<script>
	import { getAssetList } from '@/api/asset/assetLedgerApi.js';
	import { getResourceSave } from '@/api/asset/resourceApi.js';
	import { getCurrentCommunity, getCommunityId } from '@/utils/vc.js';
	export default {
		name: 'ResourceManageDialog',
		props: {
			dialogVisible: Boolean,
		},
		data() {
			return {
				loading: false,
				options: [],
				CurrentCommunity: [getCurrentCommunity()],
				form: {
					resourceNo: '',
					resourceName: '',
					resourceType: '',
					area: '',
					assetId: '',
					communityId: getCommunityId(),
					rentPrice: '',
					initialStatus: '',
				},
				rules: {
					resourceNo: { required: true, message: '请填写资源编号', trigger: 'blur' },
					resourceName: { required: true, message: '请填写资源名称', trigger: 'blur' },
					resourceType: { required: true, message: '请选择资源类型', trigger: 'change' },
					communityId: { required: true, message: '请选择所属项目', trigger: 'change' },
					assetId: { required: true, message: '请选择关联资产', trigger: 'change' },
					area: [
						{ required: true, message: '请填写面积', trigger: 'blur' },
						{ type: 'number', min: 0.0001, message: '面积必须大于0', trigger: 'blur' },
					],
					rentPrice: [
						{ required: true, message: '请填写租金单价', trigger: 'blur' },
						{ type: 'number', min: 0.0001, message: '租金单价必须大于0', trigger: 'blur' },
					],
				},
			};
		},
		watch: {
			dialogVisible(val) {
				if (val) {
					this.remoteMethod('');
				}
			},
		},
		methods: {
			async remoteMethod(query) {
				try {
					this.loading = true;
					const res = await getAssetList({
						communityId: getCommunityId(),
						keyword: query.trim(),
					});
					this.options = res || [];
				} catch {
					this.options = [];
				} finally {
					this.loading = false;
				}
			},
			async fetchGetResourceSave() {
				try {
					const res = await getResourceSave(this.form);
					console.log(res, 'getResourceSave');
					this.$message.success('新增成功');
					this.$emit('updateSuccess');
					this.handleClose();
				} catch (err) {
					this.$message.error('新增失败');
				}
			},
			handleClose() {
				this.$refs.form.resetFields();
				this.$refs.form.validateField();
				this.$emit('update:dialogVisible', false);
			},
			handleSubmit() {
				this.$refs.form.validate(valid => {
					if (!valid) return;
					console.log('数据', this.form);
					this.fetchGetResourceSave();
				});
			},
		},
	};
</script>

<style scoped lang="scss">
	:deep(.plan-dialog) {
		.no-spinner .el-input__inner::-webkit-outer-spin-button,
		.no-spinner .el-input__inner::-webkit-inner-spin-button {
			-webkit-appearance: none;
			margin: 0;
		}

		.no-spinner .el-input__inner[type='number'] {
			-moz-appearance: textfield; /* Firefox */
		}
		.el-dialog__body {
			max-height: 60vh; // 控制最大高度
			overflow-y: auto; // 开启纵向滚动
		}
		/* 整体滚动条宽度 */
		.el-dialog__body::-webkit-scrollbar {
			width: 6px;
		}

		/* 滚动条轨道 */
		.el-dialog__body::-webkit-scrollbar-track {
			background: #f5f5f5;
			border-radius: 3px;
		}

		/* 滑块 */
		.el-dialog__body::-webkit-scrollbar-thumb {
			background: #bbbbbb;
			border-radius: 3px;
			transition: all 0.3s;
		}

		/* hover 时 */
		.el-dialog__body::-webkit-scrollbar-thumb:hover {
			background: #a8a8a8;
		}
	}
</style>
